import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterType", "clearCatalogFilters", "searchResultsRedirect"];
import UISearchInput from 'UIComponents/input/UISearchInput';
import { useDebouncedTextInput
// @ts-expect-error Could not find a declaration file for module
} from '../../../hooks/searchParamHooks';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const RouterSearchInput = _ref => {
  let {
      filterType,
      clearCatalogFilters,
      searchResultsRedirect
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [inputValue, onChange] = useDebouncedTextInput(filterType, 300, clearCatalogFilters, searchResultsRedirect);
  return /*#__PURE__*/_jsx(UISearchInput, Object.assign({
    "data-test-id": `filter-type-${filterType}`,
    onChange: onChange,
    placeholder: I18n.text(`learningCenter.topFilters.${filterType}.placeholder`),
    value: inputValue
  }, rest));
};
export default RouterSearchInput;